import * as React from 'react';
import styled from 'styled-components';
import {
  compose,
  space,
  color,
  layout,
  typography,
  SpaceProps,
  ColorProps,
  LayoutProps,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M12 5.867c3.29 0 6.24 2.723 7.805 5.707.14.267.14.585 0 .852-1.565 2.984-4.507 5.707-7.805 5.707s-6.24-2.723-7.805-5.707a.916.916 0 010-.852C5.761 8.59 8.711 5.867 12 5.867zM12 4c-4.414 0-8.201 3.68-9.857 7.644a.924.924 0 000 .712C3.799 16.321 7.586 20 12 20c4.413 0 8.201-3.68 9.857-7.644a.924.924 0 000-.712C20.201 7.679 16.413 4 12 4zm0 6a2 2 0 012 2c0 1.1-.905 2-2 2s-2-.865-2-2 .892-2 2-2zm0-2c-2 0-4 1.58-4 4s2 4 4 4 4-1.592 4-4-2-4-4-4z"
      />
    </svg>
  );
});
export const IconSystemV2EssentialEye = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
